import React from 'react'
import { useLocation } from 'react-router-dom'

const StepMomIcon = () => {
  const location = useLocation()
  const isHalloween = !!location.pathname.includes('/halloween')
  return (
    <svg width='83' height='82' viewBox='0 0 83 82' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_dd_821_1817)'>
        <rect x='19.375' y='17' width='44' height='44' rx='10' fill={`${isHalloween ? 'url(#halloweenGradient)' : 'url(#paint0_linear_821_1817)'}`} />

        <g transform='translate(30, 28) scale(1.3)'>
          <path
            d='M15.3744 12.935L11.9698 7.40908C11.7076 6.98413 11.3043 6.84484 10.7622 6.84372L10.7435 6.84131H5.30805L5.28944 6.84372C4.7475 6.84532 4.34358 6.98413 4.082 7.40908L0.677611 12.935C0.547303 13.1447 0.486 13.3957 0.50269 13.6417C0.519058 13.8808 0.608766 14.1078 0.753517 14.2978C1.08876 14.7259 1.7143 14.8874 2.20713 14.6407L4.11345 13.7355V16.0364H11.9381V13.7355L13.8445 14.6407C14.337 14.8874 14.9631 14.7259 15.2983 14.2978C15.4429 14.1078 15.5329 13.8808 15.5491 13.6417C15.566 13.3957 15.5044 13.1443 15.3744 12.935ZM12.0417 10.6666C12.0172 10.8123 11.9803 10.9441 11.9381 11.0701V11.0795C11.7602 10.9967 11.572 10.9616 11.3883 10.969C10.9587 10.9861 10.5534 11.235 10.3562 11.6504C10.171 12.0403 10.2577 12.5126 10.4811 12.8525C9.60919 13.5573 8.67938 14.1124 8.04597 14.6377C7.26524 14.0566 6.87657 13.8722 6.26129 13.3903C6.04689 13.2222 5.82158 13.0513 5.59996 12.8738L5.58054 12.8583C5.57589 12.8549 5.65003 12.7373 5.65757 12.723C5.70379 12.6363 5.74166 12.5447 5.76846 12.4497C5.84116 12.1923 5.83619 11.9129 5.71583 11.6592C5.5186 11.2439 5.11339 10.995 4.68395 10.9778C4.49844 10.9704 4.30827 11.0062 4.1287 11.0908C4.12789 11.0884 4.12677 11.0864 4.12597 11.0842L4.11297 11.0905V11.0468C3.94463 10.5652 3.88413 10.0088 4.04942 9.48374C4.27714 8.76047 4.90509 8.18259 5.9559 8.12209C7.23909 8.11005 7.73368 8.88773 8.03008 9.4693C8.33002 8.89896 8.73555 8.20184 9.96738 8.12209C10.6796 8.11583 11.1819 8.37532 11.5083 8.67204C12.0217 9.13936 12.1812 9.84498 12.0417 10.6666Z'
            fill='white'
          />
          <path
            d='M5.35921 2.58123C5.75507 1.43532 6.83406 0.666504 8.04643 0.666504V0.666504C9.25879 0.666504 10.3378 1.43532 10.7336 2.58124L11.71 5.40765H4.38281L5.35921 2.58123Z'
            fill='white'
          />
        </g>
      </g>
      <defs>
        <filter id='filter0_dd_821_1817' x='0.375' y='0' width='82' height='82' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='0.4' />
          <feGaussianBlur stdDeviation='1.54375' />
          <feColorMatrix type='matrix' values='0 0 0 0 0.854902 0 0 0 0 0.388235 0 0 0 0 0.564706 0 0 0 0.315 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_821_1817' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='2' />
          <feGaussianBlur stdDeviation='9.5' />
          <feColorMatrix type='matrix' values='0 0 0 0 0.854902 0 0 0 0 0.388235 0 0 0 0 0.564706 0 0 0 0.63 0' />
          <feBlend mode='normal' in2='effect1_dropShadow_821_1817' result='effect2_dropShadow_821_1817' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_821_1817' result='shape' />
        </filter>
        <linearGradient id='paint0_linear_821_1817' x1='23.2612' y1='17' x2='64.5025' y2='23.8168' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#F76FAF' />
          <stop offset='1' stopColor='#FF6182' />
        </linearGradient>
      </defs>

      <defs>
        <linearGradient id='halloweenGradient' x1='0%' y1='0%' x2='100%' y2='100%'>
          <stop offset='0%' stopColor='#ED712B' />
          <stop offset='100%' stopColor='#D03C3C' />
        </linearGradient>

        <linearGradient id='defaultGradient' x1='0%' y1='0%' x2='100%' y2='100%'>
          <stop offset='0%' stopColor='#4ECDC4' />
          <stop offset='100%' stopColor='#556270' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default StepMomIcon
